module.exports = __webpack_public_path__ + "img/bsmk2.3299cf60.png";